/// <reference path="_references.ts"/>

module App.Forms {
	export class FormService {
		static $inject: string[] = ['$http', 'Constants'];
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) { }

		public getInstances(id: number, params?: any): ng.IHttpPromise<FormInstanceList[]> {
			params = params || {};
			params.service_request = id;

			return <ng.IHttpPromise<FormInstanceList[]>>this.$http.get(this.Constants.apiUrl + 'forminstance', {
				params: params
			});
		}

		public getItemInstances(id: number, params?: any): ng.IHttpPromise<FormInstanceList[]> {
			params = params || {};
			params.serviceable_item = id;

			return <ng.IHttpPromise<FormInstanceList[]>>this.$http.get(this.Constants.apiUrl + 'forminstance', {
				params: params
			});
		}

		public getInstance(id: number, params?: any): ng.IHttpPromise<FormInstance> {
			return <ng.IHttpPromise<FormInstance>>this.$http.get(this.Constants.apiUrl + 'forminstance/' + id, {
				params: params || {}
			});
		}

		public updateInstance(id: number, data: any, params?: any): ng.IHttpPromise<FormInstance> {
			return <ng.IHttpPromise<FormInstance>>this.$http.put(
				this.Constants.apiUrl + 'forminstance/' + id,
				data, {
					params: params || {}
				}
			);
		}

		public createInstance(
			formId: number,
			formType: 'admin'|'servicerequest'|'serviceableitem',
			data: any,
			params?: any
		): ng.IHttpPromise<FormInstance> {
			return <ng.IHttpPromise<FormInstance>>this.$http.post(
				this.Constants.apiUrl + 'form/' + formId + '/instance/' + formType,
				data, {
					params: params || {}
				}
			);
		}

		public getForms(params?: any): ng.IHttpPromise<FormList[]> {
			return <ng.IHttpPromise<FormList[]>>this.$http.get(this.Constants.apiUrl + 'form', {
				params: params || {}
			});
		}

		public getForm(id: number, params?: any): ng.IHttpPromise<Form> {
			return <ng.IHttpPromise<Form>>this.$http.get(this.Constants.apiUrl + 'form/' + id, {
				params: params || {}
			});
		}

		public getServiceRequestForms(params?: any): ng.IHttpPromise<FormList[]> {
			params = params || {};
			params.sr_form = 1;
			return this.getForms(params);
		}

		public deleteFormAnswerImage(formInstanceId: number, imageId: number): ng.IHttpPromise<FormInstance> {
			return this.$http.delete(`${this.Constants.apiUrl}forminstance/${formInstanceId}/image/${imageId}`);
		}
	}
}
